import { RootState } from 'store/index';
import { AccountInfoParsedIsUsResidentEnum } from '../../../../services/generatedClientFromSwagger';
import config from 'config/common';

export const kyc_fsca_regulation_currentStep = (root: RootState) => {
    const { user } = root;

    const { country, city, custom_field_dateOfBirth, isUsResident, regulationKyc } = user.userInfo;

    const steps = [
        { step: 0, questions: [2, 3, 4, 5, 6] },
        { step: 1, questions: [7, 8, 9] },
        { step: 2, questions: [10, 11, 12] },
        { step: 3, questions: [13] },
    ];

    const kyc = regulationKyc?.kycs[config.kycType || ''];
    const kycFragments = kyc?.kycFragments || {};

    const currentStep =
        steps.find((step) => {
            let questions = step.questions;
            let userQuestions = Object.keys(kycFragments);
            let stepCompleted = questions.every((r) => userQuestions?.includes(r.toString()));
            return !stepCompleted;
        }) || null;

    switch (true) {
        case Boolean(kyc?.completed):
        case isUsResident === AccountInfoParsedIsUsResidentEnum.Yes:
            return 5;
        case !country || !city || !custom_field_dateOfBirth:
            return -1;
        case currentStep !== null && Boolean(currentStep):
            return Number(currentStep?.step);
        default:
            return 5;
    }
};
